// side effect: fetch new shortArticleNumber calculation when decisions are made
import {DecisionKind} from '@viamedici-spc/configurator-ts';
import {fetchShortNumber} from '../slices/shortNumberSlice';
import {setProductModel} from '../slices/configurationSlice';
import {selectFamily, selectFamilyConfig, selectSpcIsSatisfied, selectSpcSession, selectUnsatisfied} from '../selectors';
import {spcToStoredDecisions} from '../components/spc/util/spcUtils';
import {getFilteredDecisions} from '../util/getFilteredDecisions';
import {spcExpliciteChoiceDecision} from '../util/values';
import {migrateDecisions} from '../util/migrateDecisions';
import {productModelToHousingShape} from '../valueMaps/productModelToHousingShape';

export const shortArticleNumberMiddleware = store => next => async action => {
	const result = next(action);

	// skip when feature is off
	if (store.getState().status.features.shortArticleNumber !== true) return result;



	if (store.getState().shortNumber.status !== 'loading' && action.type === 'configuration/store/fulfilled') {
		const spcSession = selectSpcSession(store.getState());

		const currentDecisions = spcToStoredDecisions(spcSession?.getDecisions());
		const isSatisfied = selectSpcIsSatisfied(store.getState());

		const familyConfig = selectFamilyConfig(store.getState());
		const createShortNumber = familyConfig?.createShortNumber || selectFamily(store.getState()) === 'LightProfile';

		// after decision(s), get the new shortArticleNumbers, when model is satisfied and createShortNumber is set for family
		if (createShortNumber && store.getState().configuration.data.projects[0].project?.productModelId && isSatisfied) {
			const configurationData = {
				decisions: getFilteredDecisions(currentDecisions)
			};
			store.dispatch(fetchShortNumber({
				prefixLevels: ['ProductModel', store.getState().configuration.data.projects[0].project.productModelId],
				data: JSON.stringify(
					{
						configurationData: configurationData
					}
				)
			}));
		}

		if (store.getState().configuration.data.projects[0].project?.dimmLevelData) {
			store.dispatch(fetchShortNumber({
				prefixLevels: ['BasicDimmingID'],
				data: JSON.stringify(
					{
						configurationData: {
							dimmLevel: store.getState().configuration.data.projects[0].project?.dimmLevelData
						}
					}
				)
			}));
		}
	}

	if (action.type === 'shortNumber/loadConfigByShortNumberLoading/fulfilled') {
		//console.log('shortNumber/loadConfigByShortNumberLoading/fulfilled', store.getState().shortNumber.data);
		const loadedPrefixLevels = store.getState().shortNumber.data.prefixLevels;
		// find the next item after 'ProductModel' in the array loadedPrefixLevels
		let model = '';
		if (loadedPrefixLevels && loadedPrefixLevels.indexOf('ProductModel') !== -1) {
			model = loadedPrefixLevels[loadedPrefixLevels.indexOf('ProductModel') + 1];
		} else {
			model = store.getState().configuration.data.projects[0].project.productModelId;
		}
		const loadedDecisions = store.getState().shortNumber.data.loadedConfig?.configurationData.decisions;
		const decisions = loadedDecisions.map(dec => spcExpliciteChoiceDecision('root::' + dec.variableId, dec.featureValue));
		const mode = store.getState().configuration?.data?.projects[0]?.project?.lastPersistedBy;

		const migrated = migrateDecisions(decisions, mode, model);
		const spcSession = selectSpcSession(store.getState());
		console.log('shortArticleNumberMiddleware makeDecisions', migrated);
		await spcSession.makeManyDecisions(migrated, {
			type: 'KeepExistingDecisions',
			conflictHandling: {type: 'Automatic'}, //{type: 'Manual', includeConstraintsInConflictExplanation: true}
		}).then(
			() => console.log('shortArticleNumberMiddleware decisions made'),
			error => console.error('shortArticleNumberMiddleware decisions failed', error)
		);
	}
	return result;
};
